export const common = {
  languages: {
    pt_br: "pt-br",
    en_us: "en-us",
  },
};
